export default __webpack_public_path__ + "static/media/atribucion-exportar.12479d1c.png";